import { api } from '../api'

const BASE_URL = '/helpdesk-notifications'

export const helpdeskNotificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUnreadHelpdeskNotifications: builder.query({
      query: () => `${BASE_URL}/unread`,
      transformResponse: (response) => response.data,
      providesTags: ['HelpdeskNotifications'],
    }),
    markHelpdeskNotificationRead: builder.mutation({
      query: (notificationId) => ({
        url: `${BASE_URL}/${notificationId}/read`,
        method: 'PATCH',
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['HelpdeskNotifications'],
    }),
  }),
})

export const { useGetUnreadHelpdeskNotificationsQuery, useMarkHelpdeskNotificationReadMutation } =
  helpdeskNotificationsApi
